import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const FTPBackUpIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M14.026 19.7117L4.77377 19.7116C3.44828 19.7116 2.37377 18.6371 2.37378 17.3116L2.37387 8.18729C2.37388 7.27337 2.37354 5.97164 2.37325 5.02909C2.37304 4.36617 2.91038 3.8294 3.5733 3.8294H9.29151L12.0565 6.78303H20.3728C21.0356 6.78303 21.5728 7.32029 21.5728 7.98303V11.1706M16.8268 16.6132L19.281 14.1706M19.281 14.1706L21.6268 16.5028M19.281 14.1706V20.1706"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.39531 17.3V9.3H10.6922V10.6945H7.08672V12.6008H10.3406V13.9953H7.08672V17.3H5.39531Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

FTPBackUpIcon.displayName = 'FTPBackUpIcon';
